import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/sun.svg'
import _imports_1 from '@/assets/images/moon.svg'


const _hoisted_1 = { class: "chartWrapperAir" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "chartContainer" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "gauge-a" }, null, -1)
const _hoisted_5 = ["alt"]
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "text right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.leftText), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", {
        class: "gauge-c",
        style: _normalizeStyle({ transform: 'rotate(' + _ctx.degreesTurned + 'deg)' })
      }, [
        _createElementVNode("img", {
          class: "sun-icon",
          src: _imports_0,
          alt: _ctx.$t('accessibility.weather.sun')
        }, null, 8, _hoisted_5),
        _createElementVNode("img", {
          class: "moon-icon",
          src: _imports_1,
          alt: _ctx.$t('accessibility.weather.moon')
        }, null, 8, _hoisted_6)
      ], 4)
    ]),
    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.rightText), 1)
  ]))
}